/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import { ClassNames, css, jsx } from '@emotion/react';
import { Icon } from 'components/icon';
import { Tooltip2 } from '@blueprintjs/popover2';

/**
 * A simple tooltip that displays infoText when you hover
 * over it
 * @param infoText Text to be displayed in tooltip
 * @returns JSX tooltip
 */
export const InfoTooltip: React.FC<InfoTooltipProps> = ({ infoText }) => {
	//For some reason the popover had a black background and white text. which is diff than the rest of the app. Just doing a css on Tooltip2
	// doesn't work. It does offer the prop "popoverClassName" but that takes a class name, not a css prop. According to Emotion website
	// the <ClassNames> component passes a css param that can be used as input to a classNames prop. As seen below. So way confuluted way
	// just to get the right styles...ugh.
	return (
		<ClassNames>
			{({css, cx}) => {
				const styles = css`
					& .bp3-popover2-content {
						background-color: white;
						color: rgb(102, 102, 102);
					}
				`;
				return (
					<Tooltip2 className={"show-on-card-hover card-title"} hoverOpenDelay={500} popoverClassName={styles} content={infoText} minimal placement="top-start">
						<Icon css={iconCss} icon="info" includeTitle={false} />
					</Tooltip2>
				)
			}}
		</ClassNames>

	);
};

interface InfoTooltipProps {
	infoText: string;
}

const iconCss = css`
	color: #6699CC; 
`;
